import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@material-ui/core'
import { Paper, Grid } from '@material-ui/core'
import { useStyles } from './style'
import _ from 'lodash'
import RefreshIcon from '@material-ui/icons/Refresh'
import * as messageTypes from '../../utils/messageTypes'
import { dashboardService } from '../../Services/Dashboard/Dashboard'
import { DisplayMessage } from '..'
import ComponentLoader from '../ComponentLoader'

const SummaryCard = (props) => {
  const classes = useStyles()
  const [summaryData, setSummaryData] = useState([])
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)
  const { currentUser } = useSelector(state => state.auth)

  const getSummary = () => {
    setLoading(true)
    dashboardService.getSummary(currentUser.account_id, currentUser.account_id)
      .then(summaryData => {
        setSummaryData(summaryData)
        setLoading(false)
        props.setTotalRequests(_.get(summaryData, 'requests', '-'))
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  // useEffect(() => {
  //   getSummary()
  // }, [])

  return (
    <>
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <Box p={2}>
        <Box className={classes.headerWrapper} display="flex">
          <Box flexGrow={1}>Summary</Box>
          {/* <Box><RefreshIcon className={classes.refreshIcon} onClick={getSummary} /></Box> */}
        </Box>
        {loading ? <ComponentLoader loading={loading} style={{ height: '320px' }} /> :
          <>
            <Paper className={classes.cardWrapper} variant="outlined">
              <Box mb={3}>
                <Grid container item sm={12}>
                  <Grid item xs={6}>
                    <div className={classes.cardData}>Virtual Power Plant</div>
                    <span className={classes.cardValue}>{_.get(summaryData, 'vpp', '-')}</span>
                  </Grid>
                  <Grid item xs={6}>
                    <div className={classes.cardData}>System Enrolled</div>
                    <span className={classes.cardValue}>{_.get(summaryData, 'systems_enrolled', '-')}</span>
                  </Grid>
                </Grid>
              </Box>
              <Grid container item sm={12}>
                <Grid item xs={6}>
                  <div className={classes.cardData}>Programs</div>
                  <span className={classes.cardValue}>{_.get(summaryData, 'programs', '-')}</span>
                </Grid>
                <Grid item xs={6}>
                  <div className={classes.cardData}>Events</div>
                  <span className={classes.cardValue}>{_.get(summaryData, 'events', '-')}</span>
                </Grid>
              </Grid>
            </Paper>
            <Paper className={classes.cardWrapper} variant="outlined">
              <Box mb={3}>
                <Grid container item sm={12}>
                  <Grid item xs={6}>
                    <div className={classes.cardData}>Accounts</div>
                    <span className={classes.cardValue}>{_.get(summaryData, 'accounts', '-')}</span>
                  </Grid>
                  <Grid item xs={6}>
                    <div className={classes.cardData}>Users</div>
                    <span className={classes.cardValue}>{_.get(summaryData, 'users', '-')}</span>
                  </Grid>
                </Grid>
              </Box>
              <Grid container item sm={12}>
                <Grid item xs={6}>
                  <div className={classes.cardData}>Requests</div>
                  <span className={classes.cardValue}>{_.get(summaryData, 'requests', '-')}</span>
                </Grid>
              </Grid>
            </Paper>
          </>
        }
      </Box>
    </>
  )
}

export default SummaryCard